import { Component, OnInit } from '@angular/core';
import { UserService } from 'app/services/user.service';
import { Globals } from 'app/services/globals';
import { first } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms'
import { LockService } from 'app/services/lock.service';
import { ValidationHandler } from 'app/helpers/validation.handler';
@Component({
  selector: 'app-lock',
  templateUrl: './lock.component.html',
  styleUrls: ['./lock.component.scss']
})
export class LockComponent implements OnInit {
  
  get userService(): UserService {
    return this._userService
  };
  
  constructor(private _userService: UserService, private _globals: Globals,
            private lockService: LockService, private route: ActivatedRoute,
            private formBuilder: FormBuilder, private validationHandler: ValidationHandler) {
    this.passwordFormGroup = this.formBuilder.group({
      email: [''],
      password: ['', Validators.required],
      fqdn: [''],
      code: ['']
    });
  }

  isTryingUnlock: boolean = false;
  avatarRandomizer;
  passwordFormGroup: FormGroup = null;

  ngOnInit() {
    if (this._userService.currentUserValue == null) {
      location.reload();
      return;
    }

    this.avatarRandomizer = Math.random() * 10000000000;

    this.passwordFormGroup = this.formBuilder.group({
      email: [this._userService.currentUserValue.email],
      password: ['', Validators.required],
      fqdn: [localStorage.getItem('fqdn')],
      code: ['', (this._userService.currentUserValue.activated_2fa? [Validators.required]: [])]
    });
  }

  login() {
    if (this._userService.currentUserValue == null) {
      location.reload();
      return;
    }
    this.validationHandler.onSubmitCheck(this.passwordFormGroup);
    if (!this.passwordFormGroup.valid) {
      return;
    }

    this.isTryingUnlock = true;
    this._userService.login(this.passwordFormGroup.get('email').value, this.passwordFormGroup.get('password').value, 
                  this.passwordFormGroup.get('fqdn').value, this.passwordFormGroup.get('code').value, false)
      .pipe(first())
      .subscribe(
        data => {
          this.lockService.isLockScreenActive = false;
          localStorage.setItem('lockedScreen', 'false');
          this.isTryingUnlock = false;
          document.getElementsByTagName('body')[0].classList.remove("hide-v-scroll");
        },
        error => {
          this.isTryingUnlock = false;
          this.validationHandler.serverValidationHandler(error, this.passwordFormGroup);
        });
  }

  isProgressVisible(): boolean {
    return this.isTryingUnlock;
  }
}
